export default {
  options: [
    'blockType',
    'fontSize',
    'fontFamily',
    'colorPicker',
    'inline',
    'textAlign',
    'list',
    'link',
    'embedded',
    'emoji',
    'history',
  ],
}